import Footer from "../Components/Footer/Footer";
import Header from "../Components/Header/Header";
import User from "../Components/User/User";
import { useAuthContext } from "../context/AuthContext";
import user_icon from "../Media/person.svg";
import { Link } from 'react-router-dom';
// import { getToken } from "../helpers";

const Settings = () =>{
    const { user, isLoading, setUser } = useAuthContext();
    let username;
    let email;
    let address;
    console.log(user)   
    if(user!=undefined){
        // console.log(user)
        username = user.firstName ? user.firstName : user.username;
        email = user.email;
        address = user.address + "," + user.city!==null?user.city:"" + "," + user.state!==null?user.state:"" + "," +user.country!==null?user.country:"" + "," + user.postalCode!==null?user.postalCode:"";
    }
    
    const userInfo =
        {   'userName': username,
            'emailId': email,
            'address' : address
        }
    return(
        <div className="skills">
            <div className="container">
                <Header title="Settings"/>
                <div className="content-wrap bg-gradient-light">
                    <div className="banner-box">
                        <div className="greeting mb---30">
                            <div className="user-informations">
                                <p className="sub-title-text">Glad you’re here</p>
                                <div className="user--name">{username}!</div>
                            </div>
                            <div className="user-img hover-bounce"> 
                                <a href="#" className="hover-zoom">
                                    <img src={user_icon} alt="user-image"/>
                                </a>
                            </div>
                            {/* <div className="add-mode hover-bounce"><i></i>Add Mode</div> */}
                        </div>
                    </div>
                    <User user={userInfo}/>
                    <div className="button-wrap custom-skills-button mt---30"><Link to="/Profile"><button className="button-right-arrow hover-bounce">Change Password<span className="arrow-right"></span></button></Link></div>
                </div>
                <Footer />
            </div>
        </div>
    );
}
export default Settings;